import { Helmet } from "react-helmet-async";

interface PageMetaProps {
  title: string;
  description: string;
  path: string;
  ogType?: string;
  ogImage?: string;
  noindex?: boolean;
}

const BASE_URL = "https://www.crechepimpolinhos.com.br";
const DEFAULT_OG_IMAGE = `${BASE_URL}/pwa-512x512.png`;

export function PageMeta({ title, description, path, ogType = "website", ogImage, noindex = false }: PageMetaProps) {
  const canonical = `${BASE_URL}${path}`;
  const image = ogImage
    ? (ogImage.startsWith("http") ? ogImage : `${BASE_URL}${ogImage}`)
    : DEFAULT_OG_IMAGE;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:type" content={ogType} />
      <meta property="og:image" content={image} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
    </Helmet>
  );
}
